export function viewportHasCanvasWorldTransform(viewport) {
    return Boolean(viewport &&
        typeof viewport.canvasToWorld === 'function' &&
        typeof viewport.worldToCanvas === 'function');
}
export function viewportHasZoom(viewport) {
    return Boolean(viewport &&
        typeof viewport.getZoom === 'function' &&
        typeof viewport.setZoom === 'function');
}
export function viewportHasPan(viewport) {
    return Boolean(viewport &&
        typeof viewport.getPan === 'function' &&
        typeof viewport.setPan === 'function');
}
export function viewportHasFrameOfReferenceUID(viewport) {
    return Boolean(viewport &&
        typeof viewport.getFrameOfReferenceUID ===
            'function');
}
